import { TranslatableKey } from '@app/types/translatable.type';

const IconLabelsDisplayOptions: { [key: string]: TranslatableKey } = {
    addRepeat: 'components.iconLabels.addRepeat',
    airplane: 'components.iconLabels.airplane',
    alarm: 'components.iconLabels.alarm',
    arrowDown: 'components.iconLabels.arrowDown',
    arrowLeft: 'components.iconLabels.arrowLeft',
    arrowRight: 'components.iconLabels.arrowRight',
    arrowUp: 'components.iconLabels.arrowUp',
    attach: 'components.iconLabels.attach',
    birthdayCake: 'components.iconLabels.birthdayCake',
    boldHelp: 'components.iconLabels.boldHelp',
    boldInfo: 'components.iconLabels.boldInfo',
    book: 'components.iconLabels.book',
    briefcase: 'components.iconLabels.briefcase',
    bug: 'components.iconLabels.bug',
    building: 'components.iconLabels.building',
    calendar: 'components.iconLabels.calendar',
    calendarDetail: 'components.iconLabels.calendarDetail',
    calendarSuccess: 'components.iconLabels.calendarSuccess',
    cancel: 'components.iconLabels.cancel',
    check: 'components.iconLabels.check',
    checkCircle: 'components.iconLabels.checkCircle',
    chevronDown: 'components.iconLabels.chevronDown',
    chevronLeft: 'components.iconLabels.chevronLeft',
    chevronRight: 'components.iconLabels.chevronRight',
    chevronUp: 'components.iconLabels.chevronUp',
    clock: 'components.iconLabels.clock',
    close: 'components.iconLabels.close',
    coin: 'components.iconLabels.coin',
    collapse: 'components.iconLabels.collapse',
    complete: 'components.iconLabels.complete',
    copy: 'components.iconLabels.copy',
    documents: 'components.iconLabels.documents',
    download: 'components.iconLabels.download',
    dollar: 'components.iconLabels.dollar',
    dragAndDrop: 'components.iconLabels.dragAndDrop',
    edit: 'components.iconLabels.edit',
    error: 'components.iconLabels.error',
    expand: 'components.iconLabels.expand',
    file: 'components.iconLabels.file',
    filter: 'components.iconLabels.filter',
    filterFilled: 'components.iconLabels.filterFilled',
    foot: 'components.iconLabels.foot',
    fullscreen: 'components.iconLabels.fullscreen',
    gavel: 'components.iconLabels.gavel',
    gift: 'components.iconLabels.gift',
    group: 'components.iconLabels.group',
    handRaisesStop: 'components.iconLabels.handRaisesStop',
    heart: 'components.iconLabels.heart',
    help: 'components.iconLabels.help',
    helpSimple: 'components.iconLabels.helpSimple',
    home: 'components.iconLabels.home',
    image: 'components.iconLabels.image',
    infinity: 'components.iconLabels.infinity',
    info: 'components.iconLabels.info',
    infoSimple: 'components.iconLabels.infoSimple',
    list: 'components.iconLabels.list',
    meatballHorizontal: 'components.iconLabels.meatballHorizontal',
    meatballVertical: 'components.iconLabels.meatballVertical',
    menu: 'components.iconLabels.menu',
    notification: 'components.iconLabels.notification',
    orgChart: 'components.iconLabels.orgChart',
    percent: 'components.iconLabels.percent',
    plus: 'components.iconLabels.plus',
    profile: 'components.iconLabels.profile',
    print: 'components.iconLabels.print',
    stop: 'components.iconLabels.stop',
    questionMark: 'components.iconLabels.questionMark',
    recruiting: 'components.iconLabels.recruiting',
    refresh: 'components.iconLabels.refresh',
    remove: 'components.iconLabels.remove',
    loading: 'components.iconLabels.loading',
    repeatOnce: 'components.iconLabels.repeatOnce',
    rocket: 'components.iconLabels.rocket',
    record: 'components.iconLabels.record',
    play: 'components.iconLabels.play',
    search: 'components.iconLabels.search',
    settings: 'components.iconLabels.settings',
    speechBubble: 'components.iconLabels.speechBubble',
    star: 'components.iconLabels.star',
    starRating: 'components.iconLabels.starRating',
    subscribe: 'components.iconLabels.subscribe',
    subtract: 'components.iconLabels.subtract',
    success: 'components.iconLabels.success',
    trash: 'components.iconLabels.trash',
    visibilityEnabled: 'components.iconLabels.visibilityEnabled',
    visiblityDisabled: 'components.iconLabels.visiblityDisabled',
    warning: 'components.iconLabels.warning',
    wind: 'components.iconLabels.wind',
    wrench: 'components.iconLabels.wrench',
    lock: 'components.iconLabels.lock',
    openInNew: 'components.iconLabels.openInNew',
    folder: 'components.iconLabels.folder',
    drive: 'components.iconLabels.drive',
    grippy: 'components.iconLabels.grippy',
    eye: 'components.iconLabels.eye',
    playback: 'components.iconLabels.playback',
    bulb: 'components.iconLabels.bulb',
    checkFilledCircle: 'components.iconLabels.checkFilledCircle',
    thumbsUp: 'components.iconLabels.thumbsUp',
    unselectedRadio: 'components.iconLabels.unselectedRadio',
    stronglyDisagree: 'components.iconLabels.stronglyDisagree',
    somewhatDisagree: 'components.iconLabels.somewhatDisagree',
    neitherAgreeNorDisagree: 'components.iconLabels.neitherAgreeNorDisagree',
    somewhatAgree: 'components.iconLabels.somewhatAgree',
    stronglyAgree: 'components.iconLabels.stronglyAgree',
    thumbUp: 'components.iconLabels.thumbUp',
    thumbDown: 'components.iconLabels.thumbDown',
    addElement: 'components.iconLabels.addElement',
    link: 'components.iconLabels.link',
};

export { IconLabelsDisplayOptions };
